import { render, staticRenderFns } from "./revisionShow.vue?vue&type=template&id=1879a129"
import script from "./revisionShow.vue?vue&type=script&lang=js"
export * from "./revisionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports